// extracted by mini-css-extract-plugin
export default {"emptyState":"G2EYp8"};